import * as types from './mutation-types'


export const loadQvctPopulation = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/survey/population/collection', data).then((response) => {
            commit(types.LOAD_QVCT_POPULATION, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const storeQvctPopulation = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/survey/population', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateQvctPopulation = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/survey/population/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteQvctPopulation = ({commit}, {id}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/qvct/survey/population/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
